import type { GraphQLFormattedError } from 'graphql';

type GraphqlErrorExtensions = {
    category?: string;
};

export const magentoCustomErrorCategories = {
    invalidPhoneNumber: 'invalid-phone-number',
    confirmPhoneNumberRequired: 'confirmation-required',
    invalidInput: 'graphql-input',
    invalidSmsCode: 'invalid-sms-code',
    phoneLimitReached: 'graphql-phone-limit',
    showMessage: 'show-message',
    orderReturnResendEmailRateLimitExceeded: 'order-return-resend-email-rate-limit-exceeded',
    codeAlreadySent: 'code_already_sent',
    passwordResetLimit:'password-reset-limit',
    passwordResetCustomerNotFound: 'password-reset-customer-not-found',
    cartCareClubCouponConflict: 'care-club-coupon-code-category-collision',
};

export class GraphqlError extends Error {
    public readonly extensions?: GraphqlErrorExtensions;

    constructor(public readonly errors: GraphQLFormattedError[]) {
        super(errors[0]?.message ?? 'GraphQL error occured');

        this.extensions = errors[0]?.extensions;
    }
}

export function isGraphQlError(error: unknown): error is GraphqlError {
    return error instanceof GraphqlError;
}
